<!-- Generator: Adobe Illustrator 26.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg
    version="1.1"
    id="Ebene_3"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 164.7 36.6"
    style="enable-background:new 0 0 164.7 36.6;"
    xml:space="preserve"
>
    <style type="text/css">
        .st0 {
            fill: #0169b3;
        }
        .st1 {
            fill: #0069b3;
        }
        .st2 {
            fill: #0068b4;
        }
    </style>
    <g>
        <g>
            <rect x="36.2" y="7.4" class="st0" width="13.2" height="3.9" />
            <path
                class="st0"
                d="M51.1,0H27.7c-0.2,0-0.3,0.2-0.3,0.3v18.2h23.7v-4.3H34.5V4.3h16.6V0z"
            />
        </g>
        <path
            class="st0"
            d="M62.4,18.5h11c2.8,0,5.1-2.3,5.1-5.1V5.1c0-2.8-2.3-5.1-5.1-5.1H53.9c-0.2,0-0.3,0.2-0.3,0.3v18.2h7V4.3h9.1
		c1.6,0,2.9,1.3,2.9,2.9v4.1c0,1.6-1.3,2.9-2.9,2.9h-7.3V18.5z"
        />
        <path
            class="st0"
            d="M126.4,11.3v7.3h6V3.7c0-2-1.7-3.7-3.7-3.7h-20.8c-0.3,0-0.5,0.2-0.5,0.5v18h7V4.3h10.4c0.8,0,1.4,0.6,1.4,1.4
		v1.6h-10.2v3.9H126.4z"
        />
        <path
            class="st0"
            d="M105,0H88.7c-2.8,0-5.1,2.3-5.1,5.1v8.3c0,2.8,2.3,5.1,5.1,5.1H105v-4.5H92.4c-1.6,0-2.9-1.3-2.9-2.9V7.5
		c0-1.6,1.3-3,2.9-3H105V0z"
        />
        <path class="st1" d="M161.1,2.9h-0.5V0.5h-0.8V0h2.1v0.5h-0.8V2.9z" />
        <path
            class="st1"
            d="M164.7,2.9h-0.5V0.5h0l-0.5,2.4h-0.5l-0.5-2.4h0v2.4h-0.5V0h0.8l0.5,2.3h0l0.5-2.3h0.8V2.9z"
        />
        <g>
            <path
                class="st0"
                d="M154.7,11.3L154.7,11.3c2.8,0,5.1-2.3,5.1-5.1V5.1c0-2.8-2.3-5.1-5.1-5.1h-19.3c-0.3,0-0.5,0.2-0.5,0.5v18h7
			V4.3h11l0,0c1.2,0.7,1.2,2.3,0,3h-9.3v3.9h5.1l4.8,7.3h6.3L154.7,11.3z"
            />
        </g>
        <g>
            <path
                class="st0"
                d="M19.9,11.3L19.9,11.3c2.8,0,5.1-2.3,5.1-5.1V5.1c0-2.8-2.3-5.1-5.1-5.1H0.3C0.2,0,0,0.2,0,0.3v18.2h7V4.3h11
			l0,0c1.2,0.7,1.2,2.3,0,3H8.8v3.9h5.1l4.8,7.3h6.3L19.9,11.3z"
            />
        </g>
        <g>
            <g>
                <path
                    class="st2"
                    d="M2.4,30.3h1.4l2.4,6.2H4.9l-0.5-1.4H1.8l-0.5,1.4H0L2.4,30.3z M3.1,31.6L3.1,31.6l-0.9,2.6H4L3.1,31.6z"
                />
                <path class="st2" d="M9.5,30.3h1.2v5.2h2.4v1H9.5V30.3z" />
                <path class="st2" d="M14.1,30.3h3.7v1h-2.4v1.5h2.2v1h-2.2v1.7h2.4v1h-3.7V30.3z" />
                <path
                    class="st2"
                    d="M19,30.3h1.2v3.6c0,0.5,0.1,1,0.3,1.3c0.2,0.3,0.5,0.5,1,0.5c0.5,0,0.8-0.2,1-0.5c0.2-0.3,0.3-0.7,0.3-1.3
				v-3.6h1.2v4c0,1.6-0.9,2.4-2.5,2.3c-1.7,0-2.5-0.8-2.5-2.3V30.3z"
                />
                <path class="st2" d="M26.8,31.3H25v-1h4.8v1H28v5.2h-1.2V31.3z" />
                <path class="st2" d="M30.7,30.3h3.7v1H32v1.5h2.2v1H32v1.7h2.4v1h-3.7V30.3z" />
                <path
                    class="st2"
                    d="M35.7,30.3h1.3c0.3,0,0.7,0,1,0c0.3,0,0.7,0.1,0.9,0.2c0.3,0.1,0.5,0.3,0.7,0.5c0.2,0.2,0.3,0.6,0.3,1
				c0,0.4-0.1,0.7-0.3,0.9c-0.2,0.3-0.5,0.4-0.9,0.5v0c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.3,0.2,0.4l1,2.4H39l-0.7-1.9
				c-0.1-0.2-0.2-0.4-0.3-0.5C37.8,34,37.6,34,37.4,34H37v2.6h-1.2V30.3z M37,33h0.4c0.2,0,0.3,0,0.5,0c0.2,0,0.3-0.1,0.4-0.1
				c0.1-0.1,0.2-0.1,0.3-0.3c0.1-0.1,0.1-0.3,0.1-0.5c0-0.2,0-0.3-0.1-0.5c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1-0.1-0.3-0.1-0.4-0.1
				c-0.2,0-0.3,0-0.5,0H37V33z"
                />
                <path class="st2" d="M42.6,31.3h-1.8v-1h4.8v1h-1.8v5.2h-1.2V31.3z" />
                <path
                    class="st2"
                    d="M53.4,36.4c-0.5,0.1-0.9,0.2-1.4,0.2c-1,0-1.8-0.3-2.4-0.8c-0.6-0.5-1-1.3-1-2.3c0-2.2,1.2-3.3,3.4-3.3
				c0.4,0,0.9,0.1,1.4,0.3l-0.1,1c-0.2-0.1-0.5-0.2-0.7-0.3c-0.2,0-0.4-0.1-0.7-0.1c-0.6,0-1.1,0.2-1.5,0.6c-0.4,0.4-0.6,1-0.6,1.6
				c0,0.6,0.2,1.2,0.6,1.6c0.4,0.4,0.9,0.6,1.5,0.6c0.3,0,0.5,0,0.8-0.1c0.2,0,0.4-0.1,0.6-0.2L53.4,36.4z"
                />
                <path
                    class="st2"
                    d="M54.8,31.1c0.5-0.6,1.3-0.9,2.3-0.9c1,0,1.7,0.3,2.3,0.9c0.5,0.6,0.8,1.3,0.8,2.3c0,1-0.3,1.7-0.8,2.3
				c-0.5,0.6-1.3,0.9-2.3,0.9c-1,0-1.7-0.3-2.3-0.9c-0.5-0.6-0.8-1.4-0.8-2.3C54,32.4,54.3,31.7,54.8,31.1z M55.7,34.9
				c0.3,0.5,0.7,0.7,1.3,0.7c0.3,0,0.6-0.1,0.8-0.2c0.2-0.1,0.4-0.3,0.5-0.5c0.3-0.4,0.4-1,0.4-1.5c0-0.6-0.1-1.1-0.4-1.5
				c-0.3-0.4-0.7-0.7-1.3-0.7c-0.6,0-1,0.2-1.3,0.7c-0.3,0.4-0.4,0.9-0.4,1.5C55.3,34,55.5,34.5,55.7,34.9z"
                />
                <path
                    class="st2"
                    d="M61.4,30.3h2l1.5,4.7h0l1.5-4.7h2v6.2h-1.2v-5.1h0l-1.7,5.1h-1.2l-1.7-5.1l0,0v5.1h-1.2V30.3z"
                />
                <path
                    class="st2"
                    d="M69.8,30.3h1.6c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.8,0.8,0.8,1.5c0,0.7-0.2,1.2-0.7,1.5
				c-0.4,0.3-1,0.5-1.7,0.5h-0.5v2.4h-1.2V30.3z M71.1,33.2h0.4c0.3,0,0.6-0.1,0.8-0.2c0.2-0.1,0.3-0.4,0.3-0.7c0-0.2,0-0.3-0.1-0.5
				c-0.1-0.1-0.2-0.2-0.3-0.3c-0.2-0.1-0.5-0.2-0.8-0.2h-0.4V33.2z"
                />
                <path
                    class="st2"
                    d="M76.3,30.3h1.4l2.4,6.2h-1.4l-0.5-1.4h-2.5l-0.5,1.4h-1.3L76.3,30.3z M77,31.6L77,31.6l-0.9,2.6h1.8L77,31.6
				z"
                />
                <path
                    class="st2"
                    d="M81.1,30.3h1.5L85,35h0v-4.6h1.2v6.2h-1.5l-2.4-4.6h0v4.6h-1.2V30.3z"
                />
                <path
                    class="st2"
                    d="M89.4,34.1l-2.3-3.7h1.5l1.5,2.6l1.5-2.6h1.3l-2.2,3.7v2.4h-1.2V34.1z"
                />
            </g>
        </g>
    </g>
</svg>
